var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTables = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 6h16M4 10h16M4 14h16M4 18h16"
})));
export { SvgTables as ReactComponent };
export default __webpack_public_path__ + "static/media/tables.abe15d2217b50583f0d61302e5b163e2.svg";